import ButtonWrapper from '@components/common/ButtonWrapper';
import { InputWrapper } from 'react-lib/dist/components-es';
import { Inventory } from 'routes';
import { useTranslation } from 'react-i18next';

type Props = {
  formikProps: any;
  newDataViewName: string;
  setIsCreatingNew: (arg0: boolean) => void;
  actions: any;
  entityType: string;
  filterState: any;
  userDefaultFilterProp: any;
  history: any;
};

const CreateNewDataView = ({
  formikProps,
  newDataViewName,
  setIsCreatingNew,
  actions,
  entityType,
  filterState,
  userDefaultFilterProp,
  history,
}: Props) => {
  const { values } = formikProps;
  const { t } = useTranslation();
  const onClick = () => {
    actions.createNewDataView(
      values.newDataViewName,
      entityType,
      filterState,
      filterState.filterValues
    );
    if (userDefaultFilterProp) {
      history.push({
        pathname: `${Inventory.baseName}/overview/entity/`,
        state: { userDefaultFilterProp: undefined },
      });
      window.location.reload();
    }
  };
  return (
    <div>
      <span className="componentWithRightMargin">
        {t('inventory.overview.page.view.options.container.specify.view.name.label')}
      </span>
      <div className="viewNameContainer">
        <InputWrapper
          {...formikProps}
          value={newDataViewName}
          id="newDataViewName"
          name="newDataViewName"
          inputClassName="viewNameInput"
        />
      </div>
      <ButtonWrapper
        label="cancel.button"
        type="button"
        onClick={() => {
          setIsCreatingNew(false);
        }}
      />
      <ButtonWrapper
        label="details.page.create.button"
        type="button"
        className="mini marginRightButton"
        primary
        onClick={() => {
          onClick();
        }}
      />
    </div>
  );
};

export default CreateNewDataView;
